import GradePage from "@/pages/GradePage";
export default function GradeGrade6() {
  return <GradePage grade="6" />;
}
